import Task1_2 from './Task1_2';

export default Task1_2;